import { render, staticRenderFns } from "./bindMec.vue?vue&type=template&id=488080cd&scoped=true&"
import script from "./bindMec.vue?vue&type=script&lang=js&"
export * from "./bindMec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488080cd",
  null
  
)

export default component.exports